import { add, listen, qs, toggle, contains, remove } from "@fluorescent/dom";
import { getSizedImageUrl } from "@/lib/images";

import { default as updatePrices } from "@/lib/product/update-prices";

import { get, set } from "@fluorescent/storage";
import { cart } from "@/glow";

const storage = {
  get: () => get("quick_purchase_bar"),
  set: val => set("quick_purchase_bar", val),
};

const selectors = {
  productBar: "[data-quick-purchase-bar]",
  purchaseButton: "[data-quick-purchase-button]",
  hideButton: "[data-mobile-hide]",
  productForm: ".product-form",
  productTop: ".product__top",
  productImage: ".quick-purchase-bar__product-image",
  barQuantity: "[data-bar-quantity]",
  barProductTitle: "[data-bar-product-title]",
  checkoutLink: ".quick-purchase-bar__purchase-link",
  addToCartLink: ".product-form__cart-submit",
};

const classes = {
  active: "active",
  loading: "loading",
  hidden: "is-hidden",
};

export default function (container, variant) {
  const productForm = qs(selectors.productForm, container);
  const productBar = qs(selectors.productBar, container);
  const purchaseButton = qs(selectors.purchaseButton, container);
  const hideButton = qs(selectors.hideButton, container);
  const productImage = qs(selectors.productImage, container);
  const barQuantity = qs(selectors.barQuantity, container);
  const barProductTitle = qs(selectors.barProductTitle, container);
  const productQuantity = qs('input[name="quantity"]', container);
  const checkoutLink = qs(selectors.checkoutLink, container);
  const addToCartLink = qs(selectors.addToCartLink, container);

  barQuantity.innerHTML = `x ${parseInt(productQuantity.value, 10)}`;
  barProductTitle.innerHTML = variant.name;
  productBar.dataset.variantId = variant.id;

  let observer = null;

  setOffset();

  if (storage.get()) {
    add(productBar, classes.hidden);
  }

  const events = [
    listen(hideButton, "click", e => {
      setOffset();
      toggle(productBar, classes.hidden);
      storage.set(contains(productBar, classes.hidden));
    }),
    listen(purchaseButton, "click", () => {         }),
  ];

  _intObserver();

  function setOffset() {
    productBar.style.setProperty(
      "--quick-purchase-offset",
      `${productBar.clientHeight - 20}px`
    );
  }

  function _intObserver() {
    observer = new IntersectionObserver(([{ isIntersecting: visible }]) => {
      toggle(productBar, classes.active, !visible);
    });
    observer.observe(productForm);
  }

  function hideQuickPurchaseBar() {
    remove(productBar, classes.active);
    observer && observer.unobserve(productForm);
  }

  function showQuickPurchaseBar() {
    observer && observer.observe(productForm);
  }

  function update(variant) {
    // if the variant is not available, hide bar and do not update to a sold out product
    if (!variant.available) {
      hideQuickPurchaseBar();
      return;
    }

    showQuickPurchaseBar();

    updatePrices(productBar, variant);
    productBar.dataset.variantId = variant.id;

    barQuantity.innerHTML = "";
    barProductTitle.innerHTML = "";

    if (productQuantity.value > 0) {
      barQuantity.innerHTML = `x ${parseInt(productQuantity.value, 10)}`;
    }
    barProductTitle.innerHTML = variant.name;

    if (variant.featured_media) {
      const img = `<img class="image__img lazyload" data-src="${getSizedImageUrl(
        variant.featured_media.preview_image.src,
        "120x"
      )}" />`;

      productImage.innerHTML = img;
    }
  }

  const unload = () => {
    observer && observer.disconnect();
    events.forEach(unsubscribe => unsubscribe());
  };

  return { update, unload };
}
